import { FILE_UPLOAD_CONSTANTS } from '@/lib/ai/knowledge-base/types'
import type { KnowledgeSourceProvider } from './types'

export const KNOWLEDGE_SOURCE_POLL_MS = 5 * 60_000
export const KNOWLEDGE_SOURCE_REVALIDATE_MS = 24 * 60 * 60_000
export const KNOWLEDGE_SOURCE_MAX_BYTES = FILE_UPLOAD_CONSTANTS.MAX_FILE_SIZE
export const KNOWLEDGE_SOURCE_MAX_SELECTION = 100

export const KNOWLEDGE_SOURCE_PROVIDERS = [{
  id: 'google_drive' as KnowledgeSourceProvider,
  name: 'Google Drive',
  authentication: 'oauth' as const,
  selection: 'files' as const,
  multiple: true,
}] as const
